import React from 'react';

import PropTypes from 'prop-types';

import { key, mobile } from '@philips-emr/tws-utils';

import { getWeekDays } from '../calendar-util';

function Weekday({ children }) {
  return <div>{children}</div>;
}

Weekday.propTypes = {
  children: PropTypes.string,
};

function MonthlyWeekdays() {
  if (mobile.isMobile()) {
    return null;
  }

  return getWeekDays().map((weekday) => (
    <Weekday key={key('c-calendar-weekday')}>{weekday}</Weekday>
  ));
}

export default MonthlyWeekdays;
